import { NgModule, ModuleWithProviders, Provider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoldenLayoutConfiguration } from './config';
import { GoldenLayoutService } from './golden-layout.service';
import { GoldenLayoutComponent } from './golden-layout.component';
export class GoldenLayoutModule {
/**
 * @param {?} config
 * @return {?}
 */
public static forRoot(config: GoldenLayoutConfiguration): ModuleWithProviders {
    return {
      ngModule: GoldenLayoutModule,
      providers: [
        GoldenLayoutService,
        { provide: GoldenLayoutConfiguration, useValue: config }
      ]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [GoldenLayoutComponent],
  exports: [GoldenLayoutComponent],
  imports: [CommonModule]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function GoldenLayoutModule_tsickle_Closure_declarations() {
/** @type {?} */
GoldenLayoutModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
GoldenLayoutModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
